module.exports = __webpack_public_path__ + "static/media/city3.e62fffa8.jpg";